import './additional-documents.scss';

import { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { UploadFile } from '@/components/Shared/ui';
import { useAppSelector } from '@/store';

import { CreateTabContext } from '../../LlpOrder';
import type { CreateLeasingProps } from '../../widgets/create-tab';

const AdditionalDocuments: React.FC = () => {
  const { files } = useAppSelector((state) => state.llpLeasingOrder);
  const { isFieldsFrozen } = useContext(CreateTabContext);
  const { control } = useFormContext<CreateLeasingProps>();

  if (isFieldsFrozen) {
    const filteredFiles = files.filter(
      (item) => item.name && item.type === 'additionalFiles'
    );
    if (filteredFiles.length === 0) return null;
    return (
      <div className="create-tab__section">
        <h2>Дополнительные документы</h2>
        <div className="additional-documents">
          {filteredFiles.map((file) => (
            <div key={file.uuid} className="additional-documents__file">
              {file.name}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="create-tab__section">
      <h2>Дополнительные документы</h2>
      <Controller
        control={control}
        name="additionalDocuments"
        render={({ field }) => (
          <UploadFile
            {...field}
            multiple
            maxFilesCount={5}
            isFrozen={isFieldsFrozen}
          />
        )}
      />
    </div>
  );
};

export default AdditionalDocuments;
